// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .gc-form-section {
  border: 1px solid #D1D5DB;
  border-radius: 12px;
  margin-bottom: 16px;
}
:host ::ng-deep .gc-form-section .sidebar-form {
  padding: 25px;
}
:host ::ng-deep .gc-form-section .sidebar-form label {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 30px;
  color: #1E38A9;
}
:host ::ng-deep .gc-form-section .sidebar-form .p-inputtext {
  height: 54px;
  border: 1px solid #D1D5DB;
  border-radius: 6px;
  padding: 12px 16px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 30px;
  color: #1f2937;
}
:host ::ng-deep .gc-form-section .sidebar-form .p-inputtext:enabled:focus {
  box-shadow: none;
  border-color: #D1D5DB;
}
:host ::ng-deep .gc-form-section .sidebar-form textarea.p-inputtextarea {
  border: 1px solid #D1D5DB;
  border-radius: 6px;
  padding: 12px 16px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 30px;
  color: #1f2937;
  width: 100%;
  max-width: 100%;
  min-width: 100%;
  min-height: 7rem;
  box-sizing: border-box;
  resize: vertical !important;
  overflow: auto;
}
:host ::ng-deep .gc-form-section .sidebar-form textarea.p-inputtextarea:enabled:focus {
  box-shadow: none;
  border-color: #D1D5DB;
}
:host ::ng-deep .gc-form-section .sidebar-form .form-data-item .p-inputtext,
:host ::ng-deep .gc-form-section .sidebar-form .form-data-item .p-inputtextarea {
  width: 100%;
}

.assing-agncy {
  height: 54px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 12px 16px;
  display: flex;
}
.assing-agncy .assing-agncy-img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  overflow: hidden;
  background: #fff url('agency-icon-blue.8eed463b0cbddad9.svg') no-repeat center center;
  background-size: 45%;
  color: #2d388b;
  text-align: center;
  font-size: 25px;
  font-weight: 600;
  flex: 0 0 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #c7c7c7;
  padding: 4px;
}
.assing-agncy .assing-agncy-filed {
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
}

@media (max-width: 1200px) {
  .table-header {
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  .table-header .table-search-wrapper {
    width: 360px;
  }
}

.wrap-text {
  white-space: normal;
  word-wrap: break-word;
  max-width: 300px;
}

::ng-deep .form-list-tooltip {
  max-width: 300px;
  word-break: break-word;
}
::ng-deep .form-list-tooltip hr {
  border-color: rgba(0, 0, 0, 0.1);
  margin: 8px 0;
}

.form-data-icon {
  filter: invert(1);
}

:host ::ng-deep .gc-form-section .sidebar-form .p-dropdown {
  border-radius: 6px;
  border: 1px solid #D1D5DB;
  min-height: 54px;
  display: flex;
  align-items: center;
}
:host ::ng-deep .gc-form-section .sidebar-form .p-dropdown .p-dropdown-label {
  padding: 12px 16px;
  font-family: "Montserrat";
  font-weight: 500;
  font-size: 16px;
  color: #1f2937;
}
:host ::ng-deep .gc-form-section .sidebar-form .p-dropdown:not(.p-disabled).p-focus {
  box-shadow: none;
  border-color: #D1D5DB;
}
:host ::ng-deep .p-autocomplete {
  width: 100%;
}
:host ::ng-deep .p-autocomplete .p-autocomplete-input {
  width: 100%;
  border: none;
  padding: 0;
}
:host ::ng-deep .p-autocomplete .p-autocomplete-input:focus {
  box-shadow: none;
}
:host ::ng-deep .assing-agncy-filed .p-autocomplete {
  flex: 1;
}
:host ::ng-deep .p-multiselect {
  border-radius: 6px;
  border: 1px solid #D1D5DB;
  padding: 14px 8px;
  width: 100%;
  background: #fff;
  min-height: 54px;
  display: flex;
  align-items: center;
}
:host ::ng-deep .p-multiselect .p-multiselect-label {
  padding: 0;
  font-size: 16px;
  color: #6b7280;
}
:host ::ng-deep .p-multiselect .p-multiselect-trigger {
  width: 24px;
  height: 24px;
  position: absolute;
  right: 12px;
}
:host ::ng-deep .p-multiselect-panel {
  border-radius: 6px;
  margin-top: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
:host ::ng-deep .p-multiselect-panel .p-multiselect-items {
  padding: 8px;
}

.text-center {
  text-align: center;
}

.p-multiselect-wrapper {
  position: relative;
}

.loading-icon {
  color: lightgray;
  position: absolute;
  right: 3rem;
  top: 35%;
  transform: translateY(-50%);
}

:host ::ng-deep .pi-spin {
  animation: fa-spin 0.5s infinite linear !important;
}

:host ::ng-deep .pi-trash {
  margin-left: 10px !important;
}

:host ::ng-deep .p-button-danger:enabled:focus,
:host ::ng-deep .p-button-danger:enabled:active {
  background: #d32f2f;
  outline: none;
  box-shadow: none;
}`, "",{"version":3,"sources":["webpack://./src/app/form-data/form-data.component.scss"],"names":[],"mappings":"AAEE;EACE,yBAAA;EACA,mBAAA;EACA,mBAAA;AADJ;AAGI;EACE,aAAA;AADN;AAGM;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AADR;AAIM;EACE,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAFR;AAGQ;EACE,gBAAA;EACA,qBAAA;AADV;AAKM;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,2BAAA;EACA,cAAA;AAHR;AAIQ;EACE,gBAAA;EACA,qBAAA;AAFV;AAOQ;;EAEE,WAAA;AALV;;AAYA;EACE,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;AATF;AAUE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,qFAAA;EAEA,oBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;AATJ;AAWE;EACE,OAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AATJ;;AAcE;EADF;IAEI,eAAA;IACA,2BAAA;EAVF;EAWE;IACE,YAAA;EATJ;AACF;;AAYA;EACE,mBAAA;EACA,qBAAA;EACA,gBAAA;AATF;;AAYA;EACE,gBAAA;EACA,sBAAA;AATF;AAWE;EACE,gCAAA;EACA,aAAA;AATJ;;AAaA;EACE,iBAAA;AAVF;;AAeI;EACE,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AAZN;AAaM;EACE,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAXR;AAaM;EACE,gBAAA;EACA,qBAAA;AAXR;AAgBE;EACE,WAAA;AAdJ;AAeI;EACE,WAAA;EACA,YAAA;EACA,UAAA;AAbN;AAcM;EACE,gBAAA;AAZR;AAiBE;EACE,OAAA;AAfJ;AAkBE;EACE,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AAhBJ;AAkBI;EACE,UAAA;EACA,eAAA;EACA,cAAA;AAhBN;AAmBI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AAjBN;AAqBE;EACE,kBAAA;EACA,eAAA;EACA,wCAAA;AAnBJ;AAqBI;EACE,YAAA;AAnBN;;AAwBA;EACE,kBAAA;AArBF;;AAwBA;EACE,kBAAA;AArBF;;AAwBA;EACE,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;AArBF;;AAwBA;EACE,kDAAA;AArBF;;AAwBA;EACE,4BAAA;AArBF;;AAwBA;;EAEE,mBAAA;EACA,aAAA;EACA,gBAAA;AArBF","sourcesContent":["// Form section styling to match medication-alerts create/update form\n:host ::ng-deep {\n  .gc-form-section {\n    border: 1px solid #D1D5DB;\n    border-radius: 12px;\n    margin-bottom: 16px;\n\n    .sidebar-form {\n      padding: 25px;\n\n      label {\n        font-family: 'Montserrat';\n        font-style: normal;\n        font-weight: 600;\n        font-size: 15px;\n        line-height: 30px;\n        color: #1E38A9;\n      }\n\n      .p-inputtext {\n        height: 54px;\n        border: 1px solid #D1D5DB;\n        border-radius: 6px;\n        padding: 12px 16px;\n        font-family: 'Montserrat';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 30px;\n        color: #1f2937;\n        &:enabled:focus {\n          box-shadow: none;\n          border-color: #D1D5DB;\n        }\n      }\n\n      textarea.p-inputtextarea {\n        border: 1px solid #D1D5DB;\n        border-radius: 6px;\n        padding: 12px 16px;\n        font-family: 'Montserrat';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 30px;\n        color: #1f2937;\n        width: 100%;\n        max-width: 100%;\n        min-width: 100%;\n        min-height: 7rem;\n        box-sizing: border-box;\n        resize: vertical !important;\n        overflow: auto;\n        &:enabled:focus {\n          box-shadow: none;\n          border-color: #D1D5DB;\n        }\n      }\n\n      .form-data-item {\n        .p-inputtext,\n        .p-inputtextarea {\n          width: 100%;\n        }\n      }\n    }\n  }\n}\n\n.assing-agncy {\n  height: 54px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  padding: 12px 16px;\n  display: flex;\n  .assing-agncy-img {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    overflow: hidden;\n    background: #fff url(../../assets/images/agency-icon-blue.svg) no-repeat\n      center center;\n    background-size: 45%;\n    color: #2d388b;\n    text-align: center;\n    font-size: 25px;\n    font-weight: 600;\n    flex: 0 0 32px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: 1px solid #c7c7c7;\n    padding: 4px;\n  }\n  .assing-agncy-filed {\n    flex: 1;\n    position: relative;\n    display: flex;\n    align-items: center;\n  }\n}\n\n.table-header {\n  @media (max-width: 1200px) {\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    .table-search-wrapper {\n      width: 360px;\n    }\n  }\n}\n.wrap-text {\n  white-space: normal;\n  word-wrap: break-word;\n  max-width: 300px;\n}\n\n::ng-deep .form-list-tooltip {\n  max-width: 300px;\n  word-break: break-word;\n\n  hr {\n    border-color: rgba(0, 0, 0, 0.1);\n    margin: 8px 0;\n  }\n}\n\n.form-data-icon {\n  filter: invert(1);\n}\n\n:host ::ng-deep {\n  .gc-form-section .sidebar-form {\n    .p-dropdown {\n      border-radius: 6px;\n      border: 1px solid #D1D5DB;\n      min-height: 54px;\n      display: flex;\n      align-items: center;\n      .p-dropdown-label {\n        padding: 12px 16px;\n        font-family: 'Montserrat';\n        font-weight: 500;\n        font-size: 16px;\n        color: #1f2937;\n      }\n      &:not(.p-disabled).p-focus {\n        box-shadow: none;\n        border-color: #D1D5DB;\n      }\n    }\n  }\n\n  .p-autocomplete {\n    width: 100%;\n    .p-autocomplete-input {\n      width: 100%;\n      border: none;\n      padding: 0;\n      &:focus {\n        box-shadow: none;\n      }\n    }\n  }\n\n  .assing-agncy-filed .p-autocomplete {\n    flex: 1;\n  }\n\n  .p-multiselect {\n    border-radius: 6px;\n    border: 1px solid #D1D5DB;\n    padding: 14px 8px;\n    width: 100%;\n    background: #fff;\n    min-height: 54px;\n    display: flex;\n    align-items: center;\n\n    .p-multiselect-label {\n      padding: 0;\n      font-size: 16px;\n      color: #6b7280;\n    }\n\n    .p-multiselect-trigger {\n      width: 24px;\n      height: 24px;\n      position: absolute;\n      right: 12px;\n    }\n  }\n\n  .p-multiselect-panel {\n    border-radius: 6px;\n    margin-top: 4px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n\n    .p-multiselect-items {\n      padding: 8px;\n    }\n  }\n}\n\n.text-center {\n  text-align: center;\n}\n\n.p-multiselect-wrapper {\n  position: relative;\n}\n\n.loading-icon {\n  color: lightgray;\n  position: absolute;\n  right: 3rem;\n  top: 35%;\n  transform: translateY(-50%);\n}\n\n:host ::ng-deep .pi-spin {\n  animation: fa-spin 0.5s infinite linear !important;\n}\n\n:host ::ng-deep .pi-trash {\n  margin-left: 10px !important;\n}\n\n:host ::ng-deep .p-button-danger:enabled:focus,\n:host ::ng-deep .p-button-danger:enabled:active {\n  background: #d32f2f;\n  outline: none;\n  box-shadow: none;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
